const columns = [
  {
    title: '中控型号',
    dataIndex: 'model',
    key: 'model',
    align: 'center',
    sorter: true,
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    align: 'center',
  },
  {
    title: '最后修改时间',
    dataIndex: 'lastModificationTime',
    key: 'lastModificationTime',
    align: 'center',
    scopedSlots: { customRender: 'lastModificationTime' },
    sorter: true,
    width: '15%',
  },
  {
    title: '操作',
    key: 'action',
    width: '25%',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
const selectOption = [
  {
    value: 'model',
    label: '中控型号',
  },
  {
    value: 'remark',
    label: '备注',
  },
];
const optionEnum = {
  MODEL: 'model',
  REMARK: 'remark',
};
export default {
  columns,
  selectOption,
  optionEnum,
};
